<template>
  <!-- name: '我要捐-二级页面容器' -->
  <div class="secondWrap">
    <GoBack
      :title="title"
      :nextPath="$route.query.id ? '/donateThird' : ''"
      :nextQuery="
        $route.query.id
          ? JSON.stringify({
              title: '项目详情',
              id: $route.query.id,
              nextPath: '/home',
            })
          : ''
      "
    />

    <Rangking v-if="title === '排行榜'" />

    <History v-else-if="title === '历年捐赠项目'" />
    <MyDonate v-else-if="title === '我的捐赠'" />

    <div v-else style="margin-top: 47px">
      <SelectTab
        :selectTabList="selectTabList"
        :curSelectTab="curSelectTab"
        @selectTab="selectTab"
      />
      <ClothesList v-if="curSelectTab === '捐衣'" />
      <ThingsList v-if="curSelectTab === '捐物'" />
      <FastClothes v-if="curSelectTab === '快捷捐衣'" />
      <FastThings v-if="curSelectTab === '快捷捐物'" />
      <!-- <Together v-if="curSelectTab === '一起捐'" /> -->
    </div>
  </div>
</template>

<script>
import GoBack from "@/components/GoBack";
import SelectTab from "@/components/SelectTab";
import ClothesList from "./components/clothesList.vue";
import ThingsList from "./components/thingsList.vue";
import FastClothes from "./components/fastClothes.vue";
import FastThings from "./components/fastThings.vue";
// import Together from "./components/together.vue";
import Rangking from "./components/rangking";
import History from "./components/history.vue";
import MyDonate from "./components/myDonate.vue";
export default {
  components: {
    GoBack,
    SelectTab,
    ClothesList,
    ThingsList,
    FastClothes,
    FastThings,
    // Together,
    Rangking,
    History,
    MyDonate,
  },
  data() {
    return {
      selectTabList: ["捐衣", "快捷捐衣", "捐物", "快捷捐物", "一起捐"],
      curSelectTab: "",
      title: "我要捐",
    };
  },
  created() {
    this.title = this.$route.query.title ? this.$route.query.title : this.title;
    this.curSelectTab = this.$route.query.curSelectTab ? this.$route.query.curSelectTab : localStorage.getItem('curSelectTab')
    localStorage.setItem("curSelectTab", this.curSelectTab);
  },
  methods: {
    selectTab(item) {
      this.curSelectTab = item;
      localStorage.setItem("curSelectTab", item);
      if (item === "一起捐") {
        this.$toast.fail("暂时不开放此功能");
      }
    },

  },

};
</script>

<style lang="scss" scoped>
.secondWrap {
  height: calc(100% - 100px);
  width: 100%;
  background: #f5f5f5;
  overflow: hidden;
  // padding-bottom: 37px;
}
</style>
